<template>
    <span class="go-btn"
          v-on:click="$emit('click')">
        <span class="go-btn__highlight">
        <slot>

        </slot>
 </span>
    </span>
</template>

<script>
    export default {
        name: "GoBtn",

    }
</script>

<style lang="scss">
    .go-btn {
        background: linear-gradient(180deg, #FFE141 0%, #FFD600 100%);
        border-radius: 60px;
        box-shadow: 0px 4px 4px rgba(255, 217, 16, 0.16), 0px 3px 0px #F4CD03;
        color: #333333;
        text-transform: uppercase;
        font-size: 18px;
        text-align: center;
        width: 100%;
        height: 80px;
        display: flex;
        text-decoration: none;
        font-weight: 700;
        user-select: none;
        overflow: hidden;
        letter-spacing: -.3px;
        z-index: 10000;
        min-height: 80px;

        &__highlight {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 100%;
            padding-top: 8px;
            height: 100%;
            cursor: pointer;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0.04);
        }

    }

</style>